import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/apps/web/app/global-error.tsx");
